(function () {
  var targetSelector = '[data-shipping-delivery-accordion="dynamic"] [data-shipping-delivery-content]';
  var estimatedShippingSelector = '.ot-estimated-shipping';
  var scheduled = false;

  function moveShippingWidget() {
    scheduled = false;

    var target = document.querySelector(targetSelector);
    if (!target) {
      return;
    }

    var widget = document.querySelector(estimatedShippingSelector);
    if (!widget || !widget.textContent.trim()) {
      return;
    }

    if (widget.parentElement !== target) {
      var originalWrapper = widget.closest('.product_custom_liquid');
      target.appendChild(widget);
      if (originalWrapper) {
        originalWrapper.hidden = true;
      }
    }

    var accordionItem = target.closest('[data-shipping-delivery-accordion]');
    if (accordionItem) {
      accordionItem.hidden = false;
    }
  }

  function scheduleMove() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(moveShippingWidget);
  }

  function start() {
    scheduleMove();

    new MutationObserver(scheduleMove).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
